module.exports = __webpack_public_path__ + "static/img/banner1.ba9c21a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/banner1.jpg
// module id = bvHn
// module chunks = 1